<template>
  <a-card size="small" :bordered="false">
    <template slot="title">
      <span style="margin-right: 4px">任务流程使用精准测试占比</span>
    </template>
    <div id="wk-use-rate" :style="{ height: height, width: width }" />
  </a-card>
</template>

<script>
import { accurateWorkflowAnalysis } from '@/api/data/workflow';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      myChart: null,
      option: {
        grid: {
          left: '2%',
          right: '2%',
          bottom: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category'
        },
        legend: {},
        yAxis: [
          {
            type: 'value',
            splitNumber: 4,
            splitLine: {
              show: true, // 显示分割线
              lineStyle: {
                color: ['rgba(0,0,0,0.1)'], // 分割线的颜色，可以设置为数组来显示不同颜色的虚线段
                width: 1, // 分割线的宽度
                type: 'dashed' // 分割线类型，'dashed' 表示虚线
              }
            }
          }
        ],
        series: [
          {
            type: 'bar',
            stack: 'number',
            itemStyle: {
              normal: {
                color: '#67C23A'
              }
            }
          },
          {
            type: 'bar',
            stack: 'number',
            itemStyle: {
              normal: {
                color: '#D4D7DE'
              }
            }
          }
        ],
        dataset: {
          source: [],
          dimensions: ['日期', '使用', '未使用']
        }
      }
    };
  },
  watch: {
    filterForm() {
      this.getWorkflowUseRateData();
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar');

    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    this.myChart = echarts.init(document.getElementById('wk-use-rate'));
    this.getWorkflowUseRateData();
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getWorkflowUseRateData() {
      this.loading = true;
      accurateWorkflowAnalysis({ ...this.filterForm })
        .then(res => {
          this.option.dataset.source = res.data;
          this.loading = false;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped lang="less"></style>
